import React, { useEffect, useState, useMemo, useCallback , useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { differenceInDays } from "date-fns";
import {
  //   getEmployeeListPersonsListed,
  setTheEmployeeRangetwo,
  setTheEmployeeRangeOne,
  setUserDeleteActions,
  setTheProfileSignatureActions,
  setClientBranchSearchAction,
  setGeoLoactionStateAction,
  setZoneActions,
  setRegionActions,
  SetTheDashboardClientList,
  settheEmployeeActionState_reliever,
  settheEmployeeActionRegion_reliever,
  settheEmployeeActionZone_reliever,
  setTheEmpoyeeAction_branch_reliever,
  SetTheBlacklistEditsActions,
  resetUnblockActions_opretions,
  setTablePositionPersist,
  setTheEmpoyeeActionBlock_reliever,
  setTheReliever_Actions,
  setTheUserObjects,
  setTheBranchObject,
  setthe_Reliever_actionsemployeee_actions_forEmployee_filter
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import _ from "lodash";
import Delete from "../../AppComponent/Popup/Delete";
import Select from "react-select";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import useDebouncedEffect from "use-debounced-effect";
import { Employee_edit } from "./Employee_edit";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import BlockImage from "../../../Assets/AppComponent/Overall_icons/Block_icons_final.svg";
import Swal from "sweetalert2";
import SiteTransferIm from "../../../Assets/AppComponent/Overall_icons/site_transfe_icon.svg";
import BlackListCeatePoup from "../Blacklist/BlackListCreatePop";
import SiteCreateEdit from "../SiteTransfer/SiteCreateEdit";

const Relieverlist = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const Swal = require("sweetalert2");
 const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  );
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(today);

  var st = convert(state.EmployeeVerificationsNeed.EmployeeRangeOne);
  var et = convert(state.EmployeeVerificationsNeed.EmployeeRangeTwo);

  const [range, setrange] = useState(
    state.EmployeeVerificationsNeed.EmployeeRangeOne == "" ? [] : [st, et]
  );
  const [dtpageindex, setdtPageindex] = useState(TablePositionPersist?.EmployeeActions_reliever_access?.page==undefined?1:TablePositionPersist.EmployeeActions_reliever_access.page);
  const [dtpagesize, setdtPagesize] = useState(10); 
  const [search, setsearch] = useState(TablePositionPersist?.EmployeeActions_reliever_access?.search == "" || TablePositionPersist?.EmployeeActions_reliever_access?.search ==undefined? "":TablePositionPersist.EmployeeActions_reliever_access.search);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [OldEmp, setOldEMp] = useState( state?.EmployeeVerificationsNeed?.Reliever_Employee_actions_Employee_filter_old_new ? state?.EmployeeVerificationsNeed?.Reliever_Employee_actions_Employee_filter_old_new: {
    label: "NEW EMPLOYEE",
    value: false,
  });
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [nameList4, setOptions4] = useState([]);
  const [EmployeeIDs, setEmployeeIDs] = useState();
  const [createpoup, setcreatepoup] = useState(false);
  const [EmployeeIDsblacklist, setEmployeeIDsblack] = useState();
  const [createblack, setcreatepoupblack] = useState(false);

  const [datas, setData] = useState({
    state: state.EmployeeVerificationsNeed.EmployeeActions_relieverState?.value,
    zone: state.EmployeeVerificationsNeed?.EmployeeAction_reliever_Zone?.value,

    region: state.EmployeeVerificationsNeed.EmployeeAction_relieverRegion?.value,
  });

  const [records, setrecords] = useState(null);
  const [EditPopup, seteditpopup] = useState(false);
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Clientsearch: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch
  );

  const [nameList5, setOptions5] = useState([]);

  const [multiselect, setMuliselect] = useState(
    state.EmployeeVerificationsNeed.EmployeeActions_relieverState
  );
  const [multiselect1, setMuliselect1] = useState(
    state.EmployeeVerificationsNeed.EmployeeAction_relieverRegion
  );
  const [multiselect3, setMuliselect3] = useState(
    state.EmployeeVerificationsNeed.EmployeeAction_reliever_Zone
  );
  const [searchBranch, setSearch] = useState("");
  const [Client, setClients] = useState(
    state.EmployeeVerificationsNeed.EmployeeAction_RelieverBranch?.value
  );
 const oldemloyeeOptions = [
    {
      value: true,
      label: "EXISTING EMPLOYEE",
    },
    {
      value: false,
      label: "NEW EMPLOYEE",
    },
  ];


  const Block_lists = [
 
    {
      value: true,
      label: "BLOCKED EMPLOYEES",
    },
  ];
  const [BlockEmp, setBlockEMp] = useState(
    state?.EmployeeVerificationsNeed?.Block_request_Options_emp_actions_reliever  ? state?.EmployeeVerificationsNeed?.Block_request_Options_emp_actions_reliever  : {
    label: "",
    value: "",
  });
  const [Block_request, setblockrequesr] = useState({ black_list: state?.EmployeeVerificationsNeed?.Block_request_Options_emp_actions_reliever?.value ? state?.EmployeeVerificationsNeed?.Block_request_Options_emp_actions_reliever?.value  :"" });

  const [oldemplo, setoldemp] = useState({ old_employee: state?.EmployeeVerificationsNeed?.Reliever_Employee_actions_Employee_filter_old_new ? state?.EmployeeVerificationsNeed?.Reliever_Employee_actions_Employee_filter_old_new?.value : false });


  useEffect(() => {
    const payload = {
      search: searchBranch,
      page_size: 30,
      page: 1,
      data: datas,
      client: "",
      month: "",
      year: "",
      is_reliever:true,
    };
    dispatch(setClientBranchSearchAction(payload));

    //  console.log(state.ClientBranch.ClientBranchess, "asdasd");
  }, [searchBranch]);
  const HandleInputBranch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch: e,
    });
  };

  // useEffect(() => {
  //   const payloads = {
  //     search: SearchedVal.stateSearch,
  //     page_size: "",
  //     page: 1,
  //   };
  //   dispatch(setGeoLoactionStateAction(payloads));
  // }, [SearchedVal.stateSearch]);

  // //--------------_Zone---------------
  // useEffect(() => {
  //   const payloads = {
  //     search: SearchedVal.zoneSearch,
  //     page_size: 20,
  //     page: 1,
  //     counts: 1,
  //     region_id: datas.region,
  //   };
  //   dispatch(setZoneActions(payloads));
  // }, [datas.region, SearchedVal.zoneSearch]);
  useEffect(() => {
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions5(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  //-----Region---------
  // useEffect(() => {
  //   const payloads = {
  //     search: SearchedVal.regionSearch,
  //     page_size: 20,
  //     page: 1,
  //     counts: 1, //-----only we ----get----the----selected regions , the--id only
  //     state: datas.state,
  //   };
  //   dispatch(setRegionActions(payloads));
  //   //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
  // }, [datas.state, SearchedVal.regionSearch]);

  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });

      // console.log(objectArray , "objectArray");
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.branch_code
          ? `${element.branch_code}-${element.client_name.toUpperCase()}`
          : element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, searchBranch]);
console.log(TablePositionPersist?.EmployeeActions_reliever_access ,"TablePositionPersist?.EmployeeActions_reliever_access");

  useEffect(() => {
    // if (range.length > 0 && !range.includes("NaN-aN-aN")) {
    const payloads = {
      search: search,
      page_size: 20,
      page: dtpageindex,
 
    //   state: datas.state,
    //   region: datas.region,
    //   zone: datas.zone,
      client: Client,
      black_list: Block_request?.black_list,
      is_reliever :"true",
      old_employee: oldemplo.old_employee,
    };
    // if (
    //   state.Reliever_fetching_response.Reliever_listed_record_hold.length == 0 ||
    //   TablePositionPersist?.EmployeeActions_reliever_access?.page != dtpageindex ||
    //   TablePositionPersist?.EmployeeActions_reliever_access?.search != search ||
    //   TablePositionPersist?.EmployeeActions_reliever_access?.client != Client ||
    // //   TablePositionPersist?.EmployeeActions_reliever_access?.zone != datas.zone ||
    // //   TablePositionPersist?.EmployeeActions_reliever_access?.region != datas.region ||
    // //   TablePositionPersist?.EmployeeActions_reliever_access?.state != datas.state ||
    //         TablePositionPersist?.EmployeeActions_reliever_access?.black_list != Block_request?.black_list 


    //   // apiTriggerCount == true
    // ) {  
    //   dispatch(getEmployeeListPersonsListed(payloads));
     dispatch(setTheReliever_Actions(payloads)); ///for listout the employeee


    dispatch(
      setTablePositionPersist({ data: payloads, pageName: "EmployeeActions_reliever_access" })
    );
    // }
        currentRef.current.scrollTop=sessionStorage.getItem("EmployeeActions_relieverPageTableScrollPosition")

  }, [search, dtpageindex, oldemplo, datas, Client, Block_request]);

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    // console.log(value, "vlues");
    setdtPageindex(1);

    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },

    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      // appearance: "default",
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const columns = [
    {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
          if (
            row.row.original.id != undefined &&
            row.row.original.id != null
          ) {
            const userId = row.row.original.id;
            const lastFourDigits = userId.slice(-6);
            return <p className="m-0">{lastFourDigits}</p>;
          }
        },
      },
    // {
    //   Header: "U-ID",
    //   accessor: "user_id.local_uid",
    //   Cell: ({ row }) => {
    //     const userId = row.original?.user_id?.local_uid;

    //     // Handle null, undefined, empty string, or whitespace
    //     const displayValue =
    //       userId == null || String(userId).trim() == "" ? "--" : userId;

    //     return <p className="PTAGs">{displayValue}</p>;
    //   },
    // },

    // oldemplo.old_employee &&
   {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
            >
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                  row.row.original.user_id?.user_uid != undefined &&
                  row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
    {
      Header: "Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <p
              className="PTAGs"
              data-tooltip-id="my-tooltip"
              data-tooltip-content={`${formattedTime}`}
            >
              {`${row.row.original.created_at.slice(0, 10)}`}
            </p>
          </>
        );
      },
    },

    {
      Header: "Employee Name",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <>
            <div
              className="UserName"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              style={{ position: "relative" }} // Ensure the tooltip is positioned correctly
            >
              {row.row.original.user_id != null &&
              row.row.original.user_id != undefined &&
              row.row.original.user_id != "" &&
              row.row.original.user_id.first_name != null &&
              row.row.original.user_id.first_name != undefined &&
              row.row.original.user_id.first_name != "" ? (
                <div className="">
                  <span

                  // data-tooltip-id="list-ToolTips"
                  // data-tooltip-content={row.row.original.user_id.first_name}
                  >
                    {row.row.original.user_id.first_name.length > 10 ? (
                      <>
                        {capitalizeFirstLetter(
                          row.row.original.user_id.first_name.slice(0, 9)
                        )}
                        ...
                      </>
                    ) : (
                      <>
                        {capitalizeFirstLetter(
                          row.row.original.user_id.first_name
                        )}
                      </>
                    )}
                  </span>
                  {showTooltip && (
                    <div className="custom-tooltip">
                      {row.row.original.user_id.first_name}
                    </div>
                  )}
                </div>
              ) : (
                <>--</>
              )}
            </div>
          </>
        );
      },
    },

    {
      Header: "Mobile",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id != null &&
            row.row.original.user_id.phone_number != null &&
            row.row.original.user_id.phone_number != "" &&
            row.row.original.user_id.phone_number != undefined ? (
              <>
                {row.row.original.user_id.phone_number != undefined ? (
                  <div className="UserName MobileNumber">
                    <span>{row.row.original.user_id.phone_number}</span>
                  </div>
                ) : (
                  <div className="UserName MobileNumber">
                    <span>---</span>
                  </div>
                )}
              </>
            ) : (
              <div className="UserName MobileNumber">
                <span>{"----"}</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "Aadhaar Number",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.aadhar_number != null &&
            row.row.original.aadhar_number != undefined &&
            row.row.original.aadhar_number != "" &&
            row.row.original.aadhar_number != undefined ? (
              <div className="UserName MobileNumber">
                <span>{row.row.original.aadhar_number}</span>
              </div>
            ) : (
              <div className="UserName MobileNumber">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      Header: "Pan Number",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.pan_number != null &&
            row.row.original.pan_number != undefined &&
            row.row.original.pan_number != "" &&
            row.row.original.pan_number != undefined ? (
              <div className="UserName MobileNumber">
                <span>{row.row.original.pan_number}</span>
              </div>
            ) : (
              <div className="UserName MobileNumber">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "Account Number",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.account_number != null &&
            row.row.original.account_number != undefined &&
            row.row.original.account_number != "" &&
            row.row.original.account_number != undefined ? (
              <div className="UserName MobileNumber">
                <span>{row.row.original.account_number}</span>
              </div>
            ) : (
              <div className="UserName MobileNumber">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
    //           {
    //             Header: "Zone",
    //             accessor: "",
    //             Cell: (row) => {
    //               return (
    //                 <>
    //                   {row.row.original.user_id != null &&
    //                   row.row.original.user_id.zone_id != null &&
    //                   row.row.original.user_id.zone_id != undefined ? (
    //                     <>
    //                       {row.row.original.user_id.zone_id != undefined  && row.row.original.user_id.zone_id.length > 0 ? (
    //                         <div className="UserName">
    //                           <span

    //                           >
    //                             {/* {row.row.original.user_id.zone_id.zone_name} */}

    //                             {row.row.original.user_id.zone_id.map((item) => {
    //                                console.log(item ,"203912309item",item.zone_name);

    //                               return <>{item.zone_name != "" && item.zone_name != null &&item.zone_name.length > 10 ?

    //   <p
    //   data-tooltip-id="list-ToolTips"
    //   data-tooltip-content={item.zone_name}
    //    className="MobileNumber"
    //   >{item.zone_name.slice(0,8)}</p>
    //   :

    //   <>
    //   {item.zone_name != null && item.zone_name !="" ?
    //   <p                               data-tooltip-id="list-ToolTips"
    //    className="MobileNumber"
    //                                 data-tooltip-content={item.zone_name}>{item.zone_name}</p>
    //   : <>---</> }
    // </>

    //                               }</>;
    //                             }
    //                             )}
    //                           </span>
    //                         </div>
    //                       ) : (
    //                         <div className="UserName MobileNumber">
    //                           <span>---</span>
    //                         </div>
    //                       )}
    //                     </>
    //                   ) : (
    //                     <div className="UserName MobileNumber">
    //                       <span>{"----"}</span>
    //                     </div>
    //                   )}
    //                 </>
    //               );
    //             },
    //           },
    {
      Header: "Zone",
      accessor: "",
      Cell: (row) => {
        const [hoveredIndex, setHoveredIndex] = useState(null); // Keep track of which zone is being hovered over

        return (
          <>
            {row.row.original.user_id != null &&
            row.row.original.user_id.zone_id != null &&
            row.row.original.user_id.zone_id != undefined ? (
              <>
                {row.row.original.user_id.zone_id.length > 0 ? (
                  <div className="UserName">
                    <span className="PTAGs">
                      {row.row.original.user_id.zone_id.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            {item.zone_name.length > 10 ? (
                              <p
                                className="PTAGs"
                                onMouseEnter={() => setHoveredIndex(index)} // Set index on hover
                                onMouseLeave={() => setHoveredIndex(null)} // Remove hover index when not hovering
                                style={{ position: "relative" }} // Ensure relative position for tooltip
                              >
                                {item.zone_name.slice(0, 8)}...
                                {hoveredIndex === index && (
                                  <div className="custom-tooltip">
                                    {item.zone_name}
                                  </div>
                                )}
                              </p>
                            ) : (
                              <p
                                className="PTAGs"
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                style={{ position: "relative" }}
                              >
                                {item.zone_name}
                                {hoveredIndex === index && (
                                  <div className="custom-tooltip">
                                    {item.zone_name}
                                  </div>
                                )}
                              </p>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </span>
                  </div>
                ) : (
                  <div className="UserName PTAGs">
                    <span>---</span>
                  </div>
                )}
              </>
            ) : (
              <div className="UserName PTAGs">
                <span>{"----"}</span>
              </div>
            )}
          </>
        );
      },
    },

    // {
    //     Header: "Client",
    //     accessor: "",
    //     Cell: (row) => {
    //       return (
    //         <>
    //           {row.row.original.client_id != null &&
    //           row.row.original.client_id != undefined &&
    //           row.row.original.client_id.client_name !="" &&
    //           row.row.original.client_id.client_name != undefined ? (
    //             <div className="UserName MobileNumber">
    //               <span

    //               data-tooltip-id="list-ToolTips"
    //               data-tooltip-content={row.row.original.client_id.client_name}

    //               >{row.row.original.client_id.client_name.length > 16 ?

    //             <>
    //             {row.row.original.client_id.client_name.slice(0,14)}..
    //             </>
    //             :
    //             <>{row.row.original.client_id.client_name}</>

    //             }</span>
    //             </div>
    //           ) : (
    //             <div className="UserName MobileNumber">
    //               <span>---</span>
    //             </div>
    //           )}
    //         </>
    //       );
    //     },
    //   },
    // {
    //   Header: "Branch",
    //   accessor: "",
    //   Cell: (row) => {
    //     const [showTooltip, setShowTooltip] = useState(false);

    //     return (
    //       <>
    //         {row.row.original.client_id != null &&
    //         row.row.original.client_id != undefined &&
    //         row.row.original.client_id.client_name != "" &&
    //         row.row.original.client_id.client_name != undefined ? (
    //           <div
    //             className="UserName"
    //             onMouseEnter={() => setShowTooltip(true)}
    //             onMouseLeave={() => setShowTooltip(false)}
    //             style={{ position: "relative" }} // Relative positioning for tooltip placement
    //           >
    //             <span style={{ display: "flex" }}>
    //               {row.row.original.client_id.client_name.length > 12 ? (
    //                 <>
    //                   {row.row.original.client_id.client_name.slice(0, 12)}...
    //                 </>
    //               ) : (
    //                 <>{row.row.original.client_id.client_name}</>
    //               )}
    //             </span>

    //             {/* Custom tooltip */}
    //             {showTooltip && (
    //               <div className="custom-tooltip">
    //                 {row.row.original.client_id.client_name}
    //               </div>
    //             )}
    //           </div>
    //         ) : (
    //           <div className="UserName">
    //             <span>---</span>
    //           </div>
    //         )}
    //       </>
    //     );
    //   },
    // },

    {
      Header: "Branch",
      accessor: "",
      Cell: (row) => {
        const [showTooltip, setShowTooltip] = useState(false);
    
        const client = row?.row?.original?.client_id;
        const branchCode = client?.branch_code ?? "";
        const clientName = client?.client_name ?? "";
    
        // Full label for tooltip
        const fullLabel = branchCode
          ? `${branchCode} - ${clientName}`
          : clientName;
    
        // Short display (truncate client name only)
        const shortName =
          clientName.length > 12 ? `${clientName.slice(0, 12)}...` : clientName;
    
        const shortLabel = branchCode
          ? `${branchCode} - ${shortName}`
          : shortName;
    
        return (
          <>
            {client && clientName ? (
              <div
                className="UserName"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                style={{ position: "relative" }}
              >
                <span>{shortLabel}</span>
    
                {showTooltip && (
                  <div className="custom-tooltip">{fullLabel}</div>
                )}
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    // oldemplo.old_employee &&
       {
  Header: "Status",
  accessor: "",
  Cell: (row) => {
    const user = row.row.original.user_id;

    if (!user) return "--";

    const isActive = user.is_active;
    const isExited = row.row.original?.is_exited;

    if (isExited) {
      return (
        <p
          className="m-0"
          style={{ color: "#d9534f", fontWeight: 600 }}
        >
          Exited
        </p>
      );
    }

    return (
      <p
        className="m-0"
        style={{ color: isActive ? "green" : "orange" }}
      >
        {isActive ? "Active" : "Inactive"}
      </p>
    );
  },
},


    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        const [hovered, setHovered] = useState(null); // Hover state for tooltips
        console.log(row.row.original.id, "029340");
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              {Block_request?.black_list != true && (

              <button
                type="button"
                class="btn SiteTransferBtm"
                onClick={(e) => {
                  e.stopPropagation();
                  setDeleteId(row.row.original.user_id.id);
                  setDeletePopup(true);
                }}
                                                    style={{ background: "#d8e2fb", color: "white", position: "relative" }}
          
                                onMouseEnter={() => setHovered("Delete")}
                                onMouseLeave={() => setHovered(null)}
              >
             
                  <span className="ExcelSheetImages">
                                  <img src={DeleteImages} />
                                  {hovered === "Delete" && (
                                    <div className="custom-tooltip">Delete</div>
                                  )}
                                </span>
              </button>
                            )}

              {/* {oldemplo.old_employee == true && (
                <button
                  className=" btn Status"
                  component="span"
                  onClick={(e) => {
                    e.stopPropagation();
                    seteditpopup(true);
                    setrecords(row.row.original);
                  }}
                >
                  <span className="OuterActionSpan">
                    <span className="EditImages">
                      <img src={EditImages} />
                    </span>
                    <span className="ActionsList"> Edit </span>
                  </span>
                </button>
              )} */}
                            {oldemplo.old_employee == true && (
                              // <button
                              //   className=" btn Status"
                              //   component="span"
                              //   onClick={(e) => {
                              //     e.stopPropagation();
                              //     seteditpopup(true);
                              //     setrecords(row.row.original);
                              //   }}
                              // >
                              //   <span className="OuterActionSpan">
                              //     <span className="EditImages">
                              //       <img src={EditImages} />
                              //     </span>
                              //     <span className="ActionsList"> Edit </span>
                              //   </span>
                              // </button>
                                <button
                                class="btn SiteTransferBtm"
                                style={{ background: "#d8e2fb", color: "white", position: "relative" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  seteditpopup(true);
                                  setrecords(row.row.original);
                                }}
              
                                onMouseEnter={() => setHovered("Edit")}
                                onMouseLeave={() => setHovered(null)}
                                disabled={row.row.original?.is_exited}
              
                              >

                                <span className="ExcelSheetImages">
                                  <img src={EditImages} />
                                  {hovered === "Edit" && (
                                    <div className="custom-tooltip">Edit</div>
                                  )}
                                </span>
                              </button>
                            )}
              
              

                     {
                            Block_request?.black_list == false && 
                            row.row.original != undefined &&
                              row.row.original.user_id != undefined &&
                              row.row.original.user_id != null ? (
                              <button
                                class="btn SiteTransferBtm"
                                style={{ background: "#d8e2fb", color: "white", position: "relative" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                   /// branch details 
                                  dispatch(setTheBranchObject({ value: row.row.original?.client_id?.id,
                                   label: row.row.original?.client_id?.client_name })); ///--for---site---transfer
                                                      
                                  ////-----user----Ids
                                  dispatch(
                                    setTheUserObjects({
                                      value: row.row.original.user_id.id,
                                      label: row.row.original.user_id.first_name,
                                    })
                                  );
                                  setcreatepoup(true);
                                  setEmployeeIDs("");
                                }}
              
                                onMouseEnter={() => setHovered("Site Transfer")}
                                onMouseLeave={() => setHovered(null)}
                                disabled={row.row.original?.is_exited}
              
                              >

                                <span className="ExcelSheetImages">
                                  <img src={SiteTransferIm} />
                                  {hovered === "Site Transfer" && (
                                    <div className="custom-tooltip">Site Transfer</div>
                                  )}
                                </span>
                              </button>
                            ) : null}
       {
              Block_request?.black_list == false &&
              row.row.original != undefined &&
                row.row.original.user_id != undefined &&
                row.row.original.user_id != null ? (
                <>
                  <button
                    class="btn BlockBtn"
                    style={{ background: "#d8e2fb", color: "white", position: "relative" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      ////-----user----Ids
                      dispatch(
                        setTheUserObjects({
                          value: row.row.original.user_id.id,
                          label: row.row.original.user_id.first_name,
                        })
                      );
                      setcreatepoupblack(true);
                      setEmployeeIDsblack("");
                    }}
                    onMouseEnter={() => setHovered("Block")}
                    onMouseLeave={() => setHovered(null)}
                    disabled={row.row.original?.is_exited}
                  >

                    <span className="ExcelSheetImagesBlock">
                      <img src={BlockImage} />
                      {hovered === "Block" && (
                        <div className="custom-tooltip">Block</div>
                      )}

                    </span>
                  </button>
                </>
              ) : null}

              {Block_request?.black_list == true && (
                <button
                  className=" btn BlockBtn"
                  component="span"
                                                                      style={{ background: "#d8e2fb", color: "white", position: "relative" }}
          
                                onMouseEnter={() => setHovered("Unblock")}
                                onMouseLeave={() => setHovered(null)}

                  onClick={(e) => {
                    e.stopPropagation();
                    Swal.fire({
title: "Are you sure you want to unblock this employee?",
text: "Please provide your remarks to proceed.",
                      input: "textarea",
                      inputPlaceholder: "Enter remarks here...",
                      inputAttributes: {
                        "aria-label": "Enter remarks here",
                      },
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonText: "Yes",
                      cancelButtonText: "Cancel",
                      confirmButtonColor: "#234492", // theme color
                      cancelButtonColor: "#6c757d",
                      preConfirm: (remarks) => {
                        if (!remarks || remarks.trim() === "") {
                          Swal.showValidationMessage("Remarks are required!");
                          return false;
                        }
                        return remarks;
                      },
                    }).then((result) => {
                      if (result.isConfirmed) {
                        const remarks = result.value;
                        console.log("Employee unblocked:", row.row.original ,row.row.original.user_id?.id ,remarks);
                        console.log("Remarks:", remarks);
const payloads = {
  form_data:{
    unblock_reason:remarks,
  status:"unblocked",
  },
  EditId:row.row.original.user_id?.id,
  Delete_api_calls:{
          search: search,
      page_size: 20,
      page: dtpageindex,
      client: Client,
      black_list: Block_request?.black_list,
            is_reliever :"true"


  },
  Call_deleted_:"3",

}
                        // ✅ Place your unblock logic here
                        dispatch(resetUnblockActions_opretions(payloads))
                      }
                    });
                  }}
                >
                                      <span className="ExcelSheetImagesBlock">
                      <img src={BlockImage} />
                      {hovered === "Unblock" && (
                        <div className="custom-tooltip">Unblock</div>
                      )}

                    </span>
                </button>
              )}
            </div>
          </>
        );
      },
    },
  ].filter(Boolean);
  //  console.log(oldemplo.old_employee , "29034093248");

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 400),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
    // setsearch(e);
  }

  const HandleBlockemployee = (e) => {
    setdtPageindex(1);
 
    if (e != null) {
         setBlockEMp(e);
    dispatch(setTheEmpoyeeActionBlock_reliever(e))

      setblockrequesr({
        ...Block_request,
        black_list: e.value,
      });
    }else {
   setBlockEMp({value:"",labe:""});
         setblockrequesr({
        ...Block_request,
        black_list: "",
      });
    dispatch(setTheEmpoyeeActionBlock_reliever({value:"",labe:""}))

    }
  };


  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  
  const HandleOldemployee = (e) => {
    setdtPageindex(1);
    setOldEMp(e);
dispatch(setthe_Reliever_actionsemployeee_actions_forEmployee_filter(e))

    if (e != null) {
      setoldemp({
        ...oldemplo,
        old_employee: e.value,
      });
    }
  };

  const HandleSubmits = () => {
    if (DeleteID != undefined) {
      const payload = {
        DeleteID: DeleteID,
        page: dtpageindex,
        GetAPICALL: 3,
        Getapiall: {
          search: search,
          // page_size: dtpagesize,
          page_size: 20,
          page: dtpageindex,
//   state: datas.state,
//       region: datas.region,
//       zone: datas.zone,
      client: Client,
      black_list: Block_request?.black_list,
                      is_reliever :"true"

        },
      };
      setsearch("");
      dispatch(setUserDeleteActions(payload, setDeletePopup(false)));
    }
  };

  const HandleClientBranches = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      // dispatch(SetTheDashboardClientList(selectedVal));
      dispatch(setTheEmpoyeeAction_branch_reliever(selectedVal));
      setClients(selectedVal.value);
    } else if (selectedVal == null) {
      setClients("");

      dispatch(setTheEmpoyeeAction_branch_reliever({ value: "", label: "ALL" }));
      // dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
    }
  };

  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });

      setData({
        ...datas,
        region: selectedVal.value,
      });

      dispatch(settheEmployeeActionRegion_reliever(selectedVal));

      dispatch(settheEmployeeActionZone_reliever({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        region: "",
        zone: "",
      });

      setMuliselect3({ value: "", label: "ALL" });

      setMuliselect1({ value: "", label: "ALL" });
      dispatch(settheEmployeeActionRegion_reliever({ value: "", label: "ALL" }));

      dispatch(settheEmployeeActionZone_reliever({ value: "", label: "ALL" }));
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...datas,
        zone: selectedVal.value,
      });

      dispatch(settheEmployeeActionZone_reliever(selectedVal));
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        zone: "",
      });

      setMuliselect3({ value: "", label: "ALL" });
      dispatch(settheEmployeeActionZone_reliever({ value: "", label: "ALL" }));
    }
  };
  const handleSelectChange = (selectedVal) => {
    setdtPageindex(1);
    dispatch(setTheEmpoyeeAction_branch_reliever({ value: "", label: "ALL" }));

    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      setData({
        ...datas,
        state: selectedVal.value,
        region: "",
        zone: "",
      });

      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
      setClients("");

      dispatch(settheEmployeeActionState_reliever(selectedVal));
      dispatch(settheEmployeeActionRegion_reliever({ value: "", label: "ALL" }));

      dispatch(settheEmployeeActionZone_reliever({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...datas,
        state: "",
        zone: "",
        region: "",
      });
      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
      setClients("");

      dispatch(settheEmployeeActionState_reliever({ value: "", label: "ALL" }));
      dispatch(settheEmployeeActionRegion_reliever({ value: "", label: "ALL" }));

      dispatch(settheEmployeeActionZone_reliever({ value: "", label: "ALL" }));
    }
  };

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
        });
        setSearch(SearchDebounance.Clientsearch);
      }
    },
    500,
    [SearchDebounance]
  );

  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };

  ///---Region-----------------
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };

  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };

  const currentRef = useRef();
const scrollPosition = (e) => {
  const val = currentRef.current.scrollTop;
  sessionStorage.setItem("EmployeeActions_relieverPageTableScrollPosition", val);
};

console.log(state.Reliever_fetching_response.Reliever_listed_record_hold ,"state.Reliever_fetching_response.Reliever_listed_record_hold");


  return (
    <>
      <div 
                  onScroll={scrollPosition}
            ref={currentRef}      
className={stateDisplay ? "outterContent" : "inner-Content"}>

        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3 class="user-name mb-0">Reliever </h3>
          </div>
        </div>
        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            marginLeft: "0px",
            marginRight: "0px",
            marginTop: "0px ",
          }}
        >
          {/* <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect({ value: "", label: "All" });
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
              // placeholder={"Search"}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px", zIndex: 3 }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={
                multiselect1
                  ? Array.isArray(multiselect1)
                    ? multiselect1.some(
                        (item) => item.label === "ALL" || item.label === "All"
                      )
                      ? false
                      : true
                    : multiselect1.label === "ALL" ||
                      multiselect1.label === "All"
                    ? false
                    : true
                  : true
              }
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
              // placeholder={
              //   datas.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList5}
              isClearable={
                multiselect3
                  ? Array.isArray(multiselect3)
                    ? multiselect3.some(
                        (item) => item.label === "ALL" || item.label === "All"
                      )
                      ? false
                      : true
                    : multiselect3.label === "ALL" ||
                      multiselect3.label === "All"
                    ? false
                    : true
                  : true
              }
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div> */}

          <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Client
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                setdtPageindex(1);
                if (dtpageindex == 1) {
                  HandleClientBranches(e);
                  if (e != null) {
                  }
                }
              }}
                                filterOption={() => true}   

              options={nameList4}
              labelledBy="Select"
              onInputChange={HandleInputBranch}
              isClearable={
                state.EmployeeVerificationsNeed.EmployeeAction_RelieverBranch
                  ? Array.isArray(
                      state.EmployeeVerificationsNeed.EmployeeAction_RelieverBranch
                    )
                    ? state.EmployeeVerificationsNeed.EmployeeAction_RelieverBranch.some(
                        (item) => item.label === "ALL" || item.label === "All"
                      )
                      ? false
                      : true
                    : state.EmployeeVerificationsNeed.EmployeeAction_RelieverBranch
                        .label === "ALL" ||
                      state.EmployeeVerificationsNeed.EmployeeAction_RelieverBranch
                        .label === "All"
                    ? false
                    : true
                  : true
              }
              value={state.EmployeeVerificationsNeed.EmployeeAction_RelieverBranch}
            />
          </div>

        </div>

        <div style={{ padding: " 30px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={state.Reliever_fetching_response.Reliever_listed_record_hold}
            columns={columns}
            totalItems={state.Reliever_fetching_response.Total_count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            pageindex={pageindex}
            datacount={state.Reliever_fetching_response.Total_count}
            Filter={true}
                OldEmployeFilters={true}
            oldemloyeeOptions={oldemloyeeOptions}
            OldEmp={OldEmp}
                        HandleOldemployee={(e) => {
              HandleOldemployee(e);
            }}

            Block_listed_filter
            Block_lists={Block_lists}
            HandleBlockemployee={(e) => {
              HandleBlockemployee(e);
            }}
            BlockEmp={BlockEmp}
            // Separated={true}
                            searchVal={TablePositionPersist?.EmployeeActions_reliever_access?.search == "" || TablePositionPersist?.EmployeeActions_reliever_access?.search ==undefined? "":TablePositionPersist.EmployeeActions_reliever_access.search}
              search_key={true}
              
        
          />
        </div>
      </div>

      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete the Employee"}
        />
      ) : null}
      {EditPopup && (
        <Employee_edit
          show={EditPopup}
          setshow={seteditpopup}
          employee={records}
          passingpayloads={{
            // search: search,
            // page_size: 20,
            // page: dtpageindex,
            // old_employee: oldemplo.old_employee,
            // state: datas.state,
            // region: datas.region,
            // zone: datas.zone,
            // client: Client,
                  search: search,
      page_size: 20,
      page: dtpageindex,
      client: Client,
      black_list: Block_request?.black_list,
      is_reliever :"true",
      old_employee: oldemplo.old_employee,
          }}
          reliver_calls={true}
        />
      )}


       {/* ----Black----list---------------------------------- */}
      {createblack ? (
        <BlackListCeatePoup
          show={createblack}
          setShow={setcreatepoupblack}
          ActiveFor={1}
          currentPage={dtpageindex}
          EditId={EmployeeIDsblacklist}
          selectVal={""}
          datas={""}

                           Emp_old={oldemplo.old_employee}
          client_id_sfrom ={Client}
          searchemp={search}
          page_size_approved={dtpageindex}
          Count_of_block={"4"}
          black_list={Block_request?.black_list}
     
        />
      ) : null}



           <>
              {createpoup ? (
                <SiteCreateEdit
                  show={createpoup}
                  setShow={setcreatepoup}
                  currentPage={dtpageindex}
                  EditId={EmployeeIDs}
                  selectVal={""}
                  datas={""}
                       Emp_old={oldemplo.old_employee}
                client_id_sfrom ={Client}
                searchemp={search}
                page_size_approved={dtpageindex}

                          Count_of_block={"4"}
          black_list={Block_request?.black_list}
     ALL_BRANCHES={true}


                />
              ) : null}
            </>
      
    </>
  );
};

export default Relieverlist;
